import { useQuery } from "@tanstack/react-query";
import { ActiveAntsReceivingDiscrepancyService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { IssueStatus } from "src/types";

export const useActiveAntsReceivingDiscrepancy = (
  activeAntsPurchaseOrderId: string,
  activeAntsReceivingDiscrepancyService: ActiveAntsReceivingDiscrepancyService,
  receivingDiscrepancyStatus?: IssueStatus
) => {
  const {
    data: activeAntsReceivingDiscrepancy,
    error: fetchError,
    isLoading,
    refetch,
    isRefetching
  } = useQuery({
    queryKey: queryKeys.activeAntsReceivingDiscrepancy(activeAntsPurchaseOrderId, receivingDiscrepancyStatus),
    queryFn: async () => {
      try {
        return await activeAntsReceivingDiscrepancyService.getActiveAntsReceivingDiscrepancy(
          activeAntsPurchaseOrderId,
          receivingDiscrepancyStatus
        );
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!activeAntsPurchaseOrderId,
    retry: false
  });

  return { activeAntsReceivingDiscrepancy, fetchError, isLoading, refetch, isRefetching };
};
